/*
 * Automatically generated by 'ng g ng-alain:plugin icon'
 */

import {
  AlipayCircleOutline,
  ArrowDownOutline,
  CopyrightOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GithubOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  SettingOutline,
  TaobaoCircleOutline,
  ToolOutline,
  UserOutline,
  WeiboCircleOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AlipayCircleOutline,
  ArrowDownOutline,
  CopyrightOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GithubOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  SettingOutline,
  TaobaoCircleOutline,
  ToolOutline,
  UserOutline,
  WeiboCircleOutline
];
